import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles((theme) => ({
  sliderContainer: {
    margin: '0 auto',
    overflow: 'hidden',
    position: 'relative',
  },
  sliderTrack: {
    display: 'flex',
    transition: 'transform 0.5s ease-in-out',
  },
  slide: {
    flex: '0 0 100%',
    boxSizing: 'border-box',
    position: 'relative',
    transition: 'opacity 0.5s ease-in-out',
  },
  dotsContainer: {
    marginTop: theme.spacing(3),
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
}));

export default styles;